var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 15.5,
    viewBox: "0 0 15.5 15.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 4,
    y2: 4,
    transform: "translate(5 5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 4,
    y2: 4,
    transform: "translate(5 5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelWhiteIcon);
export default __webpack_public_path__ + "static/media/cancel-white-icon.7c4c06e7bcf7488e6b6c580f5d7fcd62.svg";
export { ForwardRef as ReactComponent };